
/**
 * It creates a new script element, appends it to the body, and returns a promise that resolves when
 * the script has loaded
 * @param id - The id of the script tag.
 * @param src - The URL of the script to load.
 * @returns A promise.
 */
export const loadScript = (id, src) => {
  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById(id);

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.id = id;
      // Class to remove script after unload tour component
      script.className = "loadedScript";
      document.body.appendChild(script);

      script.onload = () => {
        resolve(script);
      };

      script.onerror = () => {
        reject(
          `Error cargando el script ${id}. Por favor, recarga la página.`
        );
      };
    }
  });
};

/**
 * It removes all the scripts that were loaded by the loadScript function.
 */
export const unloadScripts = () => {
  const existingScripts = document.querySelectorAll(".loadedScript");

  // Destroy container child nodes created by scripts loaded from loadScript
  const container = document.querySelector("#container");
  container.innerHTML = "<br />Loading...<br /><br />";

  existingScripts.forEach((script) => {
    document.body.removeChild(script);
  });
};
